
import React, { useState, useEffect } from "react";
import {
  MenuOutlined,
  UserOutlined,
  DashboardOutlined,
  LogoutOutlined,
  SettingOutlined,
  CloseOutlined,
  StarOutlined,
  HeartOutlined,
} from "@ant-design/icons";
import { Button, Layout, Menu, Dropdown, Drawer, Image } from "antd";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../Screens/breadCrumb";
import { isEmpty } from "lodash";

const { Header, Sider, Content, Footer } = Layout;

const Dashboard = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // Get current location
  const [isDarkMode, setIsDarkMode] = useState(
    () => localStorage.getItem("darkMode") === "enabled"
  );

  const [drawer, setDrawer] = useState(false);
  const [Mobile, setMobile] = useState(window.innerWidth <= 768);
  // State to control the selected menu item
  const [selectedKey, setSelectedKey] = useState("");
  const typeOfUser =
    localStorage.getItem("typeOfUser") || sessionStorage.getItem("typeOfUser");

  const loginType = localStorage.getItem("loginType");
  const newStudent = localStorage.getItem("newStudent");
  const hasMultipleStudents = localStorage.getItem("hasMultipleStudents");

  // Set selected key based on current path
  useEffect(() => {
    // Extract the main path segment after /dashboard/
    const path = location.pathname.split("/");
    let currentPath = "";
    
    if (path.length > 2 && path[1] === "dashboard") {
      currentPath = path[2]; // Get the part after /dashboard/
    }
    
    // Map path to menu key
    switch (currentPath) {
      case "myDonations":
        setSelectedKey("myDonations");
        break;
      case "Donate":
        setSelectedKey("donate");
        break;
      case "Profile":
        setSelectedKey("profile");
        break;
      default:
        // Keep current selection if not matching any specific path
        break;
    }
    
    // Save to localStorage
    if (currentPath) {
      localStorage.setItem("selected-menu-key", currentPath === "Donate" ? "donate" : currentPath);
    }
  }, [location.pathname]);

  // Handle Menu Item Selection
  const handleMenuSelect = (e) => {
    setSelectedKey(e.key);
    localStorage.setItem("selected-menu-key", e.key);
  };

  const menuItems = [
    {
      key: "myDonations",
      icon: (
        <HeartOutlined
          style={{ color: isDarkMode ? "#1890ff" : "#1890ff" }}
        />
      ),
      label: <Link to="/dashboard/myDonations">My Donations</Link>,
    },
    {
      key: "donate",
      icon: (
        <StarOutlined style={{ color: isDarkMode ? "#1890ff" : "#1890ff" }} />
      ),
      label: <Link to="/dashboard/Donate">Donate</Link>,
    },
    // {
    //   key: "examination",
    //   icon: (
    //     <DashboardOutlined
    //       style={{ color: isDarkMode ? "#1890ff" : "#1890ff" }}
    //     />
    //   ),
    //   label: (
    //     <Link
    //       to={
    //         loginType === "both" &&
    //         typeOfUser === "existingUser" &&
    //         newStudent === "false" &&
    //         hasMultipleStudents === "true"
    //           ? "/studentDropdown"
    //           : "/dashboard"
    //       }
    //     >
    //       Examination
    //     </Link>
    //   ),
    // },
  ];

  useEffect(() => {
    const handleResize = () => {
      setMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const siderWidth = collapsed ? 0 : 200;

  const toggleDrawer = () => {
    setDrawer(!drawer);
  };

  const leftMenuStyle = {
    textAlign: "center",
    backgroundColor: "#ffb948",
    padding: "0",
    borderBottom: "1px solid #e8e8e8",
    width: "100%",
    height: "75px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const siderStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    bottom: 0,
    backgroundColor: isDarkMode ? "#000" : "#ffffff",
    borderRight: "1px solid #e8e8e8",
    transition: "width 0.3s ease, opacity 0.3s ease, visibility 0.3s ease",
    opacity: collapsed ? 0 : 1,
    visibility: collapsed ? "hidden" : "visible",
    display: Mobile ? "none" : "block",
  };

  const headerStyle = {
    padding: "0 24px",
    background: isDarkMode ? "#000" : "#ffffff",
    backgroundColor: "#ffb948",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e8e8e8",
    position: "fixed",
    top: 0,
    left: Mobile ? 0 : siderWidth,
    right: 0,
    zIndex: 1000,
    height: "75px",
  };

  const filteredMenuItems = menuItems.filter((item) => {
    const loginType = localStorage.getItem("loginType");
    if (
      (item.key === "myDonations" || item.key === "donate") &&
      loginType === "donor" &&
      (typeOfUser === "annadhanam" ||
        typeOfUser === "festival" ||
        typeOfUser === "existingUser")
    ) {
      return true;
    } else if (
      item.key === "examination" &&
      typeOfUser === "examination" &&
      loginType === "student"
    ) {
      return true;
    } else if (
      (item.key === "myDonations" ||
        item.key === "donate" ||
        item.key === "examination") &&
      typeOfUser === "existingUser" &&
      loginType === "both"
    ) {
      return true;
    }
    return false; // Explicitly return false for items that don't match criteria
  });

  const handleMenuClick = () => {
    if (Mobile) {
      toggleDrawer();
    } else {
      setCollapsed(!collapsed);
    }
  };

  const handleProfile = () => {
    navigate("/dashboard/Profile");
  };

  const handleLogout = () => {
    if (typeOfUser === "annadhanam") {
      navigate("/logIn/annadhanam");
    } else if (typeOfUser === "festival") {
      navigate("/logIn/festival");
    } else if (typeOfUser === "existingUser") {
      navigate("/logIn/existingUser");
    } else if (typeOfUser === "examination") {
      navigate("/logIn/examination");
    }
    // Clear all localStorage and sessionStorage
    localStorage.clear();
    sessionStorage.clear();
  };

  const userMenu = (
    <Menu style={{ zIndex: 9999 }}>
      <Menu.Item key="profile" icon={<UserOutlined />} onClick={handleProfile}>
        Profile
      </Menu.Item>

      <Menu.Divider />
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Layout
        style={{
          minHeight: "100vh",
          background: isDarkMode ? "#333" : "#f0f2f5",
        }}
      >
        <Sider width={siderWidth} collapsed={collapsed} style={siderStyle}>
          <div style={leftMenuStyle}>
            <a
              href="https://sriramanavami.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                preview={false}
                src="/favicon.ico"
                alt="Logo"
              />
            </a>
          </div>
          <Menu
            mode="inline"
            selectedKeys={[selectedKey]} // Set the selected key here
            onSelect={handleMenuSelect}
            style={{
              height: "calc(100% - 64px)",
              borderRight: 0,
              color: isDarkMode ? "#fff" : "#595959",
              backgroundColor: isDarkMode ? "#000" : "#ffffff",
            }}
            items={filteredMenuItems}
            theme={isDarkMode ? "dark" : "light"}
          />
        </Sider>
        <Drawer
          placement="left"
          onClose={toggleDrawer}
          open={drawer} // Changed from visible to open (required for newer Ant Design versions)
          bodyStyle={{
            padding: 0,
            backgroundColor: isDarkMode ? "#000" : "#ffffff",
          }}
          style={{ backgroundColor: isDarkMode ? "black" : "white" }}
          closeIcon={
            <CloseOutlined style={{ color: isDarkMode ? "#fff" : "#000" }} />
          }
        >
          <div style={leftMenuStyle}>
            <a
              href="https://sriramanavami.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                preview={false}
                src="/favicon.ico"
                alt="Logo"
              />
            </a>
          </div>
          <Menu
            mode="inline"
            selectedKeys={[selectedKey]} // Also update selection in drawer menu
            onSelect={handleMenuSelect}
            style={{
              height: "calc(100% - 64px)",
              borderRight: 0,
              color: isDarkMode ? "#fff" : "#595959",
              backgroundColor: isDarkMode ? "#000" : "#ffffff",
            }}
            items={filteredMenuItems}
            theme={isDarkMode ? "dark" : "light"}
          />
        </Drawer>
        <Layout style={{ marginLeft: Mobile ? 0 : siderWidth }}>
          <Header style={headerStyle}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={
                  <MenuOutlined
                    style={{ color: isDarkMode ? "#fff" : "#1890ff" }}
                  />
                }
                onClick={handleMenuClick}
                style={{
                  fontSize: "30px",
                  width: 64,
                  height: 64,
                  color: isDarkMode ? "#fff" : "#1890ff",
                }}
              />
            </div>
            <Dropdown overlay={userMenu} placement="bottomRight">
              <Button
                type="text"
                icon={
                  <UserOutlined
                    style={{ color: isDarkMode ? "#fff" : "#1890ff" }}
                  />
                }
                style={{ marginLeft: 16 }}
              />
            </Dropdown>
          </Header>
          <Layout style={{ marginTop: "64px" }}>
            <Content
              style={{
                minHeight: 280,
                background: isDarkMode ? "#000" : "#ffffff",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                overflow: "auto",
              }}
            >
              {/* <BreadCrumb /> */}
              <Outlet />
            </Content>
            {/* <Footer style={footerStyle}>
            <span style={{ color: isDarkMode ? "white" : "black" }}>
              © 2024 LMS Admin Panel. All Rights Reserved.
            </span>
          </Footer> */}
          </Layout>
        </Layout>
      </Layout>
    </>
  );
};

export default Dashboard;